import { render } from "./CategoryTable.vue?vue&type=template&id=70ba5383&scoped=true"
import script from "./CategoryTable.vue?vue&type=script&lang=js"
export * from "./CategoryTable.vue?vue&type=script&lang=js"

import "./CategoryTable.vue?vue&type=style&index=0&id=70ba5383&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ba5383"]])

export default __exports__